module.exports = __webpack_public_path__ + "static/media/poppins-v15-latin-300.9ddc0491.woff2";